import React from 'react';
import { connect } from 'react-redux';
import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts';

import { available as getAvailable, list2 as getActive } from '~/actions/work';
import { list } from '~/actions/actions';

import Tag from '~/components/Tag';

import Styles from './widget.scss';

const chartColors = [
  '#0095ff',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#8042ff',
  '#ffdf42',
  '#42c1ff',
  '#ff4262'
];

class BoxCountChart extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      detailedInfo: null,
      users: {},
      available: {},
      active: []
    };
  }

  componentDidMount() {
    this.fetchInterval = setInterval(this.fetchWork.bind(this), 300000);
    this.fetchActionInterval = setInterval(
      () => list(this.props.dispatch, this.context.apiClient),
      1800000
    );
    list(this.props.dispatch, this.context.apiClient);
    this.fetchWork();
  }

  componentWillUnmount() {
    if (this.fetchInterval) {
      clearInterval(this.fetchInterval);
    }
    if (this.fetchActionInterval) {
      clearInterval(this.fetchActionInterval);
    }
  }

  getStats() {
    const { actions, indata } = this.props;
    let workCount = 0;
    const notStarted = this.state.available;
    const { paused, active } = this.state.active.reduce(
      (obj, work) => {
        if (work.paused) {
          if (!obj.paused[work.actionId]) {
            // eslint-disable-next-line no-param-reassign
            obj.paused[work.actionId] = [];
          }
          obj.paused[work.actionId].push(work);
        } else {
          if (!obj.active[work.actionId]) {
            // eslint-disable-next-line no-param-reassign
            obj.active[work.actionId] = [];
          }
          obj.active[work.actionId].push(work);
        }
        return obj;
      },
      { paused: {}, active: {} }
    );
    const actionsRet = actions
      .map(action => {
        const actionId = action.get('id');
        const actionName = action.get('name');
        const actionSettings = indata.actions && indata.actions[actionId];
        const workProps = {
          actionId,
          name: actionName
        };

        if (actionSettings) {
          [
            { label: 'Not started', value: 'notStarted' },
            { label: 'Paused', value: 'paused' },
            { label: 'In progress', value: 'active' }
          ].forEach(status => {
            if (actionSettings[status.value]) {
              workProps[status.value] = {
                name: actionSettings.title || `${actionName} - ${status.label}`,
                items:
                  { notStarted, paused, active }[status.value][actionId] || []
              };
              workCount += workProps[status.value].items.length;
            }
          });
        }

        return workProps;
      })
      .valueSeq()
      .toArray();
    return {
      workCount,
      actions: actionsRet
    };
  }

  getChartInfo(info) {
    return (info || []).reduce((arr, i) => {
      ['notStarted', 'paused', 'active'].forEach(status => {
        if (typeof i[status] !== 'undefined') {
          arr.push({
            name: i[status].name,
            value: i[status].items.length,
            boxes: i[status].items,
            fill: chartColors[arr.length % chartColors.length]
          });
        }
      });
      return arr;
    }, []);
  }

  fetchWork() {
    getAvailable(this.props.dispatch, this.context.apiClient).then(r =>
      this.setState({ available: r.data })
    );
    this.fetchActiveWork();
  }

  fetchActiveWork(skipId) {
    getActive(
      this.props.dispatch,
      this.context.apiClient,
      null,
      skipId,
      null,
      null,
      null,
      false
    ).then(r => {
      this.setState({
        active: skipId
          ? [...this.state.active, ...r.data.results]
          : r.data.results
      });
      if (r.data.more) {
        this.fetchActiveWork(r.data.skipId);
      }
    });
  }

  selectDetailedInfo(name) {
    const { detailedInfo } = this.state;
    this.setState({ detailedInfo: name === detailedInfo ? null : name });
  }

  render() {
    const { detailedInfo } = this.state;
    const { containers } = this.props;
    const info = this.getStats();
    const chartInfo = this.getChartInfo(info.actions);
    const selectedChartInfo = chartInfo.find(c => c.name === detailedInfo);

    return (
      <div className={this.props.className}>
        <div className={Styles.countChartInfo}>
          <h5 className={Styles.title}>{this.props.indata.title}</h5>
          <div>Work items: {info.workCount}</div>
          <hr />
          {chartInfo.map((entry, index) => {
            const selected = entry === selectedChartInfo;
            return (
              <div
                key={`${entry.name}_${index}`}
                onClick={() => this.selectDetailedInfo(entry.name)}
                className={`${Styles.chartInfo} ${selected &&
                  Styles.chartInfoSelected}`}
              >
                <span
                  className={Styles.chartInfoFill}
                  style={{ backgroundColor: entry.fill }}
                />
                {entry.name}: {entry.value}
              </div>
            );
          })}
        </div>
        <ResponsiveContainer
          minHeight={200}
          width="50%"
          className={Styles.countChart}
        >
          <PieChart margin={{ left: 20, right: 20, top: 20, bottom: 20 }}>
            <Pie
              isAnimationActive={false}
              data={chartInfo}
              label
              dataKey="value"
            >
              {chartInfo.map((entry, index) => (
                <Cell key={`${entry.name}_pie_${index}`} fill={entry.fill} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
        <div className="clear" />
        {selectedChartInfo && (
          <div className={Styles.selectedChartInfo}>
            <span className={Styles.title}>{selectedChartInfo.name}</span>
            <table>
              <tbody>
                {selectedChartInfo.boxes.map((box, index) => {
                  const containerId =
                    box.containerId || (box.data && box.data.containerId);
                  const container = containerId && containers.get(containerId);
                  const orderId =
                    box.orderId ||
                    (box.data && box.data.orderId) ||
                    (container && container.get('orderId'));
                  return (
                    <tr key={`box_${box.id}_${index}`}>
                      <td className={Styles.invoiceId}>
                        {orderId ? (
                          <Tag type="order" id={orderId} />
                        ) : (
                          'No order'
                        )}
                      </td>
                      <td className={Styles.boxUser}>
                        {box.userId ? (
                          <Tag type="user" id={box.userId} />
                        ) : (
                          'No user'
                        )}
                      </td>
                      <td className={Styles.boxCount}>
                        {containerId ? (
                          <Tag type="container" id={containerId} />
                        ) : (
                          'No container'
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    work: state.getIn(['work', 'items']),
    actions: state.getIn(['actions', 'items']),
    users: state.getIn(['users', 'users']),
    orders: state.getIn(['orderNew', 'items']),
    customers: state.getIn(['customersNew', 'items']),
    containers: state.getIn(['containers', 'items'])
  };
};

// Setting pure: false is required for react router to work
export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(BoxCountChart);



// WEBPACK FOOTER //
// ./app/widgets.new/BoxCountChart/widget.js